import { version } from "@azure/msal-browser-1p";

export function getMsalVersion(): string {
    return version;
}
